import { PlanDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-details';
import { GetMasterPlansRequest } from './../../../core/domain/requests/master-plan.ts/get-master-plans.request';
import {  
  MasterPlan,
  Product,
  Tag,
  PlanType,
  Plan,
  Lookup,
  OptimizePlanSignalRRequest,
  AttachSchedulerRequest,
  LocationImport,
  PostalCode
} from 'planning-portal-library/src/lib/core/domain';
import { PlanJobDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-job-details';
import { SelectedSegmentId } from 'planning-portal-library/src/lib/core/domain/models/private-location/selected-building-block-id';

export class SetMasterPlans {
  static readonly type = '[MasterPlans] Get Master Plans';

  constructor(public payload: MasterPlan[] | undefined) {}
}

export class GetProducts {
  static readonly type = '[MasterPlans] Get Products';

  constructor(public payload: Product[] | undefined) {}
}

export class GetPostalCodes {
  static readonly type = '[MasterPlans] Get Postal Codes';

  constructor(public payload: PostalCode[] | undefined) {}
}

export class GetTags {
  static readonly type = '[MasterPlans] Get Tags';

  constructor(public payload: Tag[] | undefined) {}
}
export class GetSegmentIds {
  static readonly type = '[MasterPlans] Get Segment';

  constructor(public payload: SelectedSegmentId[] | undefined) {}
}

export class SelectedMasterPlan {
  static readonly type = '[MasterPlans] Selected Master Plan';

  constructor(public payload: MasterPlan | undefined) {}
}

export class SetMasterPlanRequest {
  static readonly type = '[MasterPlans] Set Master Plan Request';

  constructor(public payload: GetMasterPlansRequest | undefined) {}
}

export class SetMasterPlanPageRefreshFlag {
  static readonly type = '[MasterPlans] Set Master Plan Page Refresh Flag';

  constructor(public payload: boolean | undefined) {}
}

export class SetMasterPlanRoutePageRefreshFlag {
  static readonly type = '[MasterPlans] Set Master Plan Route Page Refresh Flag';

  constructor(public payload: boolean | undefined) {}
}

export class SetMasterPlanLocationGroupPageRefreshFlag {
  static readonly type = '[MasterPlans] Set Master Plan Route Page Refresh Flag';

  constructor(public payload: boolean | undefined) {}
}

export class setIsCommittedFlag {
  static readonly type = '[MasterPlans] Set Is Committed Flag';

  constructor(public payload: boolean | undefined) {}
}


export class GetPlanType {
  static readonly type = '[MasterPlans] Get Plan Type';

  constructor(public payload: PlanType[] | undefined) {}
}

export class SetPlanId {
  static readonly type = '[MasterPlans] Set Plan Id';

  constructor(public payload: string | undefined) {}
}

export class GetPlanDetails {
  static readonly type = '[MasterPlans] Get Plan Details';

  constructor(public payload: PlanDetails[] | undefined) {}
}

export class SelectedPlan {
  static readonly type = '[MasterPlans] Selected Plan';

  constructor(public payload: Plan | undefined) {}
}

export class SelectedDistributionLaneId {
  static readonly type = '[MasterPlans] Selected Distribution Lane Id';

  constructor(public payload: string | undefined) {}
}


export class ClonePlan {
  static readonly type = '[MasterPlans] Clone Plan';

  constructor(public payload: boolean | undefined) {}
}
export class GetPlanLookup {
  static readonly type = '[MasterPlans] Get Plan Lookup';

  constructor(public payload: Lookup[] | undefined) {}
}

export class GetMasterPlanLookup {
  static readonly type = '[MasterPlans] Get Master Plan Lookup';

  constructor(public payload: Lookup[] | undefined) {}
}

export class SetSignalRResponseOPtimizePlan {
  static readonly type = '[MasterPlans] Set SignalR Response OPtimize Plan';

  constructor(public payload: OptimizePlanSignalRRequest | undefined) {}
}

export class SetIsPlanRevision {
  static readonly type = '[MasterPlans] Set Is Plan Revision';

  constructor(public payload: boolean | undefined) {}
}

export class GetScheduler {
  static readonly type = '[MasterPlans] Get Scheduler';

  constructor(public payload: AttachSchedulerRequest | undefined) {}
}

export class IsMasterPlanCreated {
  static readonly type = '[MasterPlans] Is Master Plan Created';

  constructor(public payload: boolean | undefined) {}
}
export class GetLocationGroupList {
  static readonly type = '[MasterPlans] Is Location Group Created';

  constructor(public payload: boolean | undefined) {}
}

export class GetMasterLocations {
  static readonly type = '[MasterPlans] Get Locations For Master Plan';

  constructor(public payload: LocationImport[] | undefined) {}
}
